import { render, staticRenderFns } from "./CustomSourceItem.vue?vue&type=template&id=8c0e0f52"
import script from "./CustomSourceItem.vue?vue&type=script&lang=js"
export * from "./CustomSourceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports